<style scoped lang="less">
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;

	.sclectlable {
		margin-right: 20px;
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #f7f7f7;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	// button:last-child {
	// 	background-color: #ff8300;
	// }

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		// text-align: center;
		color: #333;
		font-weight: 600 !important;
	}

	// /deep/ td {
	// 	text-align: center;
	// }

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		background-color: #f41127;
		text-align: center;
	}
}
</style>
<template>
	<div>
		<titles titlename="资源管理" titlecontent="这里可以管理资源" :mbx="paths"></titles>
		<div class="manageselect">
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.ProfessionalID" placeholder="请选择专业" clearable @change="getpolist()">
						<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.PR_GUID" placeholder="请选择岗位" clearable>
						<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="sclectlable">
				<!-- <p>资源类型</p> -->
				<div>
					<el-select v-model="pagesobj.RT_GUID" placeholder="请选择资源类型" clearable>
						<el-option v-for="item in rtlist" :key="item.RT_GUID" :label="item.RT_ResourceTitle" :value="item.RT_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="sclectlable">
				<!-- <p>资源名称</p> -->
				<div><el-input placeholder="请输入内容资源名称" v-model="pagesobj.ResourceName" clearable></el-input></div>
			</div>

			<div class="primarybtn" @click="getresours()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>
		<div class="resourbtn">
			<el-button @click="$router.push('/resources/resource/uploadresour')" type="primary" size="small" icon="fa fa-plus">资源上传</el-button>
			<!-- <el-button type="primary" size="small" icon="el-icon-upload">批量删除</el-button> -->
			<!-- <el-button type="primary" size="small" icon="fa fa-check">批量审核通过</el-button> -->
		</div>

		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<!-- <el-table-column type="selection" width="55"></el-table-column> -->
							<el-table-column label="资源名称" :resizable="false" width="150" prop="LR_Title">
								<template slot-scope="scope">
									<p :title="scope.row.LR_Title" style="width: 100%;">{{ scope.row.LR_Title }}</p>
								</template>
							</el-table-column>
							<el-table-column label="专业" :resizable="false" width="150" prop="pro_name">
								<template slot-scope="scope">
									<p :title="scope.row.pro_name" style="width: 100%;">{{ scope.row.pro_name }}</p>
								</template>
							</el-table-column>
							<el-table-column label="岗位" :resizable="false" width="110" prop="PR_ProfessionalName">
								<template slot-scope="scope">
									<p :title="scope.row.PR_ProfessionalName" style="width: 100%;">{{ scope.row.PR_ProfessionalName }}</p>
								</template>
							</el-table-column>
							<el-table-column label="封面图片" :resizable="false" width="120">
								<template slot-scope="scope">
									<div><img :src="scope.row.LR_SurfacePlotUrl" style="width: 100px;height: 80px;" alt="" /></div>
								</template>
							</el-table-column>
							<el-table-column label="资源类型" :resizable="false" prop="RT_ResourceTitle" width="80">
								<template slot-scope="scope">
									<p :title="scope.row.RT_ResourceTitle" style="width: 100%;text-align: center;">{{ scope.row.RT_ResourceTitle }}</p>
								</template>
							</el-table-column>
							<el-table-column label="上传者" :resizable="false" width="70" prop="ui_UserName" title="ui_UserName"></el-table-column>
							<el-table-column label="上传时间" :resizable="false" prop="LR_UploadTime"></el-table-column>
							<el-table-column label="权限" :resizable="false" prop="qxname">
								<template slot-scope="scope">
									<div style="color: #000;">
										<p :title="changesqx(scope.row.LR_Privilage)">{{ changesqx(scope.row.LR_Privilage) }}</p>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="审核状态" :resizable="false" width="100">
								<template slot-scope="scope">
									<div class="scostatus" :style="{ 'background-color': scope.row.LR_State == 1 ? '#51f477' : scope.row.LR_State == 0 ? 'rgb(255, 193, 7)' : '' }">
										{{ scope.row.LR_State == 0 ? '待审核' : scope.row.LR_State == 1 ? '审核通过' : '审核未通过' }}
									</div>
								</template>
							</el-table-column>
							<!-- <el-table-column label="上下架" prop="carriage">
								<template slot-scope="scope">
									<div class="scostatus" style="background-color: #4ec0cc;">{{ scope.row.LR_OnOrOff==1?'已上架':'已下架' }}</div>
								</template>
							</el-table-column> -->
							<el-table-column label="操作" :resizable="false" fixed="right" width="260">
								<template slot-scope="scope">
									<span><el-button plain size="mini" style="background-color: #0d6efd;" @click="gosesours(scope.row)">预览</el-button></span>
									<span v-if="scope.row.LR_State != 1 && isusersshow">
										<el-popconfirm
											title="是否通过审核？"
											confirm-button-text="通过"
											:cancelButtonText="scope.row.LR_State == 2 ? ' ' : '驳回'"
											@confirm="confirmsh(scope.row, 1)"
											@cancel="confirmsh(scope.row, 2)"
										>
											<el-button v-show="scope.row.LR_State != 1 && isusersshow" slot="reference" plain size="mini" style="background-color: #ffc107;">
												审核
											</el-button>
										</el-popconfirm>
									</span>

									<!-- 是否下架 -->
									<!-- <el-popconfirm title="是否下架？"><el-button slot="reference" size="mini" style="background-color: #17a2b8;">下架</el-button></el-popconfirm> -->
									<span><el-button plain size="mini" @click="editszy(scope.row)" style="background-color: #db4437;">编辑</el-button></span>
									<el-popconfirm title="是否删除该条记录？" @confirm="deleteresce(scope.row)">
										<el-button slot="reference" plain size="mini" style="background-color: #ec0f25;">删除</el-button>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { ResourceDetails, getResourceList, getGetProfList, getPositionList, getGetResourceTypes, ResourceReview, DeleteResource } from '@/request/api/homesview/yunhomes/yunhom.js';

import { GetzyProfList } from '@/request/api/mange/mange.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/homesview/resource/resource',
					name: '资源管理'
				}
			],
			tabsnum: 10,
			totalall: 0,
			tabindex: 1,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				RT_GUID: '',
				ProfessionalID: '',
				PR_GUID: '',
				ResourceName: ''
			},
			tabsnun: 1,
			tableData: [],
			// 获取专业、岗位、资源类型列表
			prolist: [],
			polist: [],
			rtlist: [],
			powershowobj: {},
			isusersshow: false
		};
	},
	components: {
		titles
	},
	mounted() {
		this.get();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		getqxlis() {
			let powerlist = JSON.parse(window.sessionStorage.getItem('allbtnlist'));
			if (!powerlist) {
				powerlist = window.sessionStorage.getItem('allbtnlist');
			}
			this.powershowobj.powershows = powerlist;
			this.powershowobj.routers = this.$route.path;

			for (var i = 0; i < this.powershowobj.powershows.length; i++) {
				if (this.powershowobj.powershows[i].path == this.powershowobj.routers && this.powershowobj.powershows[i].title == '审核') {
					this.isusersshow = true;
					return;
				} else {
					this.isusersshow = false;
				}
			}

			// console.log(this.isusersshow)
		},
		changetablesize() {
			this.pagesobj.pageIndex = 1;
			this.pagesobj.pageSize = this.tabsnun;
			this.getresours();
		},
		editszy(itm) {
			// 点击编辑 获取详情
			let source = {
				LR_GUID: itm.LR_GUID
			};
			ResourceDetails(source).then(res => {
				// console.log(res);
				this.$router.push('/resources/resource/uploadresour');
				window.localStorage.setItem('resources', JSON.stringify(res.data.data));
			});
		},
		gosesours(i) {
			let size = this.formatSize(i.LR_FileSize);
			let routerurl = this.$router.resolve({
				path: '/resource/resourcedetils?liguid=' + i.LR_GUID + '&size=' + size
			});
			window.open(routerurl.href, '_blank');
		},
		formatSize(bytes) {
			let units = ['KB', 'MB', 'GB', 'TB'];

			if (bytes < 1024) {
				return bytes + ' ' + units[0];
			} else if (bytes < 1024 * 1024) {
				return (bytes / 1024).toFixed(2) + ' ' + units[1];
			} else if (bytes < 1024 * 1024 * 1024) {
				return (bytes / (1024 * 1024)).toFixed(2) + ' ' + units[2];
			} else if (bytes < 1024 * 1024 * 1024 * 1024) {
				return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' ' + units[3];
			} else {
				return (bytes / (1024 * 1024 * 1024 * 1024)).toFixed(2) + ' ' + units[4];
			}
		},
		confirmsh(re, i) {
			let review = {
				LR_GUID: re.LR_GUID,
				LR_State: i
			};

			ResourceReview(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.getresours();
				}
			});
		},
		deleteresce(re) {
			let review = {
				LR_GUID: re.LR_GUID
			};
			DeleteResource(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.getresours();
				}
			});
		},
		changesqx(e) {
			if (e == 0) {
				return '全网公开（所有登录用户）';
			} else if (e == 1) {
				return '只对本院校公开';
			} else if (e == 2) {
				return '全网公开（游客、非注册用户）';
			} else {
				return '私有';
			}
		},
		indexMethod(index) {
			return index + 1;
		},
		changecurr(e) {
			// console.log(e, this.pagesobj.pageIndex);
			this.pagesobj.pageIndex = e;
			this.getresours();
		},
		get() {
			this.getqxlis();
			this.getresours();
			this.getprolist();
			this.getResourceType();
			// console.log("请求")
		},
		getprolist() {
			this.prolist = [];

			if (localStorage.getItem('uiguid') == 'f2b9986b57074d2cb2dadd07f6ee62bb') {
				getGetProfList().then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						// console.log(this.prolist)
						if (this.pagesobj.ProfessionalID !== '') {
							this.getpolist();
						}
					}
				});
			} else {
				GetzyProfList(localStorage.getItem('siguid')).then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.pagesobj.ProfessionalID !== '') {
							this.getpolist();
						}
					}
				});
			}
		},
		getpolist() {
			getPositionList(this.pagesobj.ProfessionalID).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
					// this.pagesobj.PR_GUID = res.data.data[0].PR_GUID
				}
			});
		},
		getResourceType() {
			getGetResourceTypes().then(res => {
				if (res.data.code > 0) {
					this.rtlist = res.data.data;
					// this.pagesobj.RT_GUID = res.data.data[0].RT_GUID
				}
			});
		},
		getresours() {
			getResourceList(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					// console.log(res)
					this.tableData = res.data.data.list;
					this.totalall = res.data.data.totalCount;
				}
			});
		}
	}
};
</script>
